function getPropertyValue(obj:  Object, path: string):any {
    // Split the path by dots to get the individual keys
    const keys = path.split('.');

    // Iterate through the keys to get the nested value
    let value = obj;
    for (const key of keys) {
        if (value && typeof value === 'object' && key in value) {
            //@ts-ignore
            value = value[key];
        } else {
            // If any key is not found, return undefined
            return undefined;
        }
    }

    // Return the final value
    return value;
}


/**
 * filter funkcija za iskanje po seznamu parameterov
 *
 * @param filter filter string
 * @param fields array of fields to filter by
 */
export default (filter: string, fields: Array<string>) => (item: object) => {
    if (filter === "") return true;
    const words = filter.toLocaleLowerCase().split(/[\s\t]+/);
    const found = words.map((word) => {
        return fields.slice(0).reduce((a, curr, i, arr) => {
            const value = getPropertyValue(item, curr);
            if (value) {
                a = a || (`${value}`.toLocaleLowerCase().indexOf(word) >= 0)
            }
            console.log(item,value,`${value}`, a, word, (`${value}`.toLocaleLowerCase().indexOf(word) >= 0))
            if (a) {
                arr.splice(i, arr.length);
            }
            return a;
        }, false);

    });
    return found.reduce((f, a) => f && a, true);
}
